import { fetchAllCityOperators, setSettlementCycleService } from "../../services/operatorSettlementConfigService";
import { cityOperatorsFetched, setSettlementCycle } from "../actions/operatorSettlementConfigAction";
import { createAllActionCreators } from "./actionCreatorUtil";

const operatorSettlementConfigActionCreators = {
  fetchCityOperatorsAction: {
    service: fetchAllCityOperators,
    action: cityOperatorsFetched,
  },
  setOperatorsSettlementCycleAction: {
    service: setSettlementCycleService,
    action: setSettlementCycle,
  },
};

export const {
  fetchCityOperatorsAction,
  setOperatorsSettlementCycleAction,
} = createAllActionCreators(operatorSettlementConfigActionCreators);
